import React from 'react';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { COLOR_GREY_400 } from 'src/utils/colors';

interface InvestorTypeFilterProps {
  selectedInvestorType: string;
  onChange: (value: string) => void;
}

const investorTypes = [
  { value: 'buy', label: 'Property Investor' },
  { value: 'rent', label: 'Rental Arbitrage' },
  { value: 'manage', label: 'Property Manager' },
];

const InvestorTypeFilter: React.FC<InvestorTypeFilterProps> = ({
  selectedInvestorType,
  onChange,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl
      variant="outlined"
      size="small"
      sx={{
        minWidth: 180,
        marginRight: 'auto',
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          color: '#555',
          height: '40px',
          background: '#fff',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
      }}
    >
      <Select
        value={selectedInvestorType}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{ borderRadius: '8px' }}
      >
        {investorTypes.map(type => (
          <MenuItem key={type.value} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default InvestorTypeFilter; 